import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminPanel from './components/AdminPanel';
import ExternalForm from './components/ExternalForm';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AdminPanel />} />
      <Route path="/form/:token" element={<ExternalForm />} />
    </Routes>
  );
}

export default App;
